import React, { useState } from 'react';
import { Header } from '../landing/ui/Header';
import { LoginModal } from '../auth/LoginModal';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [loginOpen, setLoginOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white">
      <Header onLoginClick={() => setLoginOpen(true)} />
      <main>{children}</main>
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  );
}
